<template>
	<v-container fluid>
    <v-card>
        <v-app-bar flat>
            <v-toolbar-title class="text-h5 black--text ml-5">
                Correspondences
            </v-toolbar-title>
        </v-app-bar>
        <v-row align="center" justify="center" class="mt-2">
            <v-text-field class="shrink" v-model='searchParam.barcodeNumber' label='Barcode Number' required>
            </v-text-field>
            <v-text-field v-model='searchParam.subject' label='Subject' class="shrink ml-5" required></v-text-field>
            <v-text-field v-model='searchParam.owner' label='Owner' class="shrink ml-5" required>
            </v-text-field>
            <v-checkbox color="green" class="ml-5 pt-5" v-model='searchParam.isActive'>
                <template v-slot:label style="margin-top:5px">
                    Active Only
                </template>
            </v-checkbox>
            <v-checkbox color="green" class="ml-5 pt-5" v-model='searchParam.isNoReference'>
                <template v-slot:label>
                    No Reference
                </template>
            </v-checkbox>
            <v-checkbox color="green" class="ml-5 pt-5" v-model='searchParam.isCancelDirection'>
                <template v-slot:label>
                    Cancel Direction
                </template>
            </v-checkbox>
            <v-btn @click="searchByFilters()" color="rgb(0, 174, 141)" class="white--text ml-5 mt-1">
                <v-icon style="color:white">mdi-search-web
                </v-icon>Search
            </v-btn>
        </v-row>
        <v-divider></v-divider>
        <v-data-table :headers="headers" :items="desserts" :items-per-page="5" class="elevation-1 px-3">
            <template v-slot:item="row">
                <tr>
                    <td>{{row.item.barcodeNumber}}</td>
                    <td>{{row.item.registeredBy}}</td>
                    <td>{{row.item.currentOwner}}</td>
                    <td>{{row.item.systemStatus}}</td>
                    <td class="red--text">{{row.item.correspondenceStatus}}</td>
                    <td>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-file</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-book-minus</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-file-restore</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-chart-line</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-wrench</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-lock</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab light small color="white" @click="check()">
                            <v-icon style="color:rgb(0, 174, 141)">mdi-checkbox-marked-circle-outline</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
	export default 
    {
		name: 'ManageCorrespondence',
		data: function () 
        {
            return {
                correspondences: [],
                searchParam: {
                    barcodeNumber: "",
                    subject: "",
                    owner: "",
                    isActive: false,
                    isNoReference: false,
                    isCancelDirection: false
                },
                headers: [
                    {
                        text: 'Barcode Number',
                        align: 'start',
                        sortable: false,
                        value: 'barcodeNumber',
                    },
                    { text: 'Registered By', value: 'registeredBy' },
                    { text: 'Current Owner', value: 'currentOwner' },
                    { text: 'System Status', value: 'systemStatus' },
                    { text: 'Correspondence Status', value: 'correspondenceStatus' },
                    { text: '', value: 'actions', sortable: false },
                ],
                desserts: [
                    {
                        barcodeNumber: 'Frozen Yogurt',
                        registeredBy: 159,
                        currentOwner: 6.0,
                        systemStatus: 24,
                        correspondenceStatus: 4.0,
                    },
                    {
                        barcodeNumber: 'Ice cream sandwich',
                        registeredBy: 237,
                        currentOwner: 9.0,
                        systemStatus: 37,
                        correspondenceStatus: 4.3,
                    },
                    {
                        barcodeNumber: 'Eclair',
                        registeredBy: 262,
                        currentOwner: 16.0,
                        systemStatus: 23,
                        correspondenceStatus: 6.0,
                    },
                    {
                        barcodeNumber: 'Cupcake',
                        registeredBy: 305,
                        currentOwner: 3.7,
                        systemStatus: 67,
                        correspondenceStatus: 4.3,
                    },
                    {
                        barcodeNumber: 'Gingerbread',
                        registeredBy: 356,
                        currentOwner: 16.0,
                        systemStatus: 49,
                        correspondenceStatus: 3.9,
                    },
                    {
                        barcodeNumber: 'Jelly bean',
                        registeredBy: 375,
                        currentOwner: 0.0,
                        systemStatus: 94,
                        correspondenceStatus: 0.0,
                    },
                    {
                        barcodeNumber: 'Lollipop',
                        registeredBy: 392,
                        currentOwner: 0.2,
                        systemStatus: 98,
                        correspondenceStatus: 0,
                    },
                    {
                        barcodeNumber: 'Honeycomb',
                        registeredBy: 408,
                        currentOwner: 3.2,
                        systemStatus: 87,
                        correspondenceStatus: 6.5,
                    },
                    {
                        barcodeNumber: 'Donut',
                        registeredBy: 452,
                        currentOwner: 25.0,
                        systemStatus: 51,
                        correspondenceStatus: 4.9,
                    },
                    {
                        barcodeNumber: 'KitKat',
                        registeredBy: 518,
                        currentOwner: 26.0,
                        systemStatus: 65,
                        correspondenceStatus: 7,
                    },
                ],
            };
        },

        methods: {
            getcorrespondences() {},
            check() {},
            searchByFilters() {
                console.log(this.searchParam)
            }
        },
    }
</script>